"use strict";
/**
 * @module Services.MetricCollectors
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A list of session metric collectors.
 */
var SessionMetricCollectorListImpl = /** @class */ (function () {
    /**
     * Create a new SessionMetricCollector instance
     *
     * @param collectors the collectors
     */
    function SessionMetricCollectorListImpl(collectors) {
        this.collectors = collectors;
    }
    return SessionMetricCollectorListImpl;
}());
exports.SessionMetricCollectorListImpl = SessionMetricCollectorListImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metric-collectors/session-metric-collector-list.js
// module id = 1269
// module chunks = 1